import React from "react";

export default function PaginationBar({
  page,
  setPage,
  pageSize,
  setPageSize,
  totalRecords,
  label = "kayıt",
  t = {},
}) {
  const totalPages = Math.max(1, Math.ceil((totalRecords || 0) / pageSize));
  const go = (p) => setPage(Math.min(Math.max(1, p), totalPages));

  const pages = Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
    if (totalPages <= 5) return i + 1;
    if (page <= 3) return i + 1;
    if (page >= totalPages - 2) return totalPages - 4 + i;
    return page - 2 + i;
  });

  const btn = (active = false) => ({
    padding: "4px 10px",
    borderRadius: 6,
    border: `1px solid ${active ? "#10b981" : (t.border?.input || "#334155")}`,
    background: active ? "#10b981" : "transparent",
    color: active ? "#fff" : (t.text?.primary || "#e5e7eb"),
    cursor: "pointer",
    fontSize: 12,
    fontWeight: 600,
    minWidth: 32,
  });

  return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:16,flexWrap:"wrap",gap:8}}>
      <div style={{display:"flex",alignItems:"center",gap:6}}>
        <span style={{color:t.text?.muted || "#94a3b8",fontSize:12}}>Sayfa başı:</span>
        {[25,50,100].map(n=>(
          <button key={n} onClick={()=>{setPageSize(n);setPage(1);}} style={btn(pageSize===n)}>{n}</button>
        ))}
      </div>

      <div style={{display:"flex",alignItems:"center",gap:4}}>
        <button onClick={()=>go(1)} disabled={page===1} style={btn(false)}>«</button>
        <button onClick={()=>go(page-1)} disabled={page===1} style={btn(false)}>‹</button>
        {pages.map(p=>(
          <button key={p} onClick={()=>go(p)} style={btn(page===p)}>{p}</button>
        ))}
        <button onClick={()=>go(page+1)} disabled={page>=totalPages} style={btn(false)}>›</button>
        <button onClick={()=>go(totalPages)} disabled={page>=totalPages} style={btn(false)}>»</button>
      </div>

      <span style={{color:t.text?.muted || "#94a3b8",fontSize:12}}>
        {totalRecords || 0} {label}
      </span>
    </div>
  );
}
